export { Pagination } from '@mantine/core'